import React, { createContext, useContext, useState } from "react"

interface FactoryContextType {
  factorySelected: string
  setFactorySelected: (id: string) => void
}

export const FactoryContext = createContext<FactoryContextType>(null!)

export const FactoryProvider = ({ children }: { children: React.ReactNode }) => {
  const [factorySelected, setFactorySelected] = useState<string>('')

  return (
    <FactoryContext.Provider value={{ factorySelected, setFactorySelected }}>
      {children}
    </FactoryContext.Provider>
  )
}

export const useFactory = () => useContext(FactoryContext)
